// O selo e o "Últ. Ponto" do cabeçalho do card seguem o BSeller na hora (API SAC, rota
// /pedidos-erp/{n}/rastreio-realtime), não o tabelão (Adnéia, 26/10/2026: "quero que os dois
// sigam o BSeller direto, deixando o tabelão").
// Por quê: o tabelão é cópia do banco da casa e atrasa. Na entrega 127719522, às 11h35 de
// 26/10, o tabelão ainda dizia "PROCESSAMENTO NA FILAL" (ponto da J&T das 05h45) e o BSeller
// já dizia "Entregue ao Cliente"; o ELO tinha movido o chamado pelo BSeller e o card desmentia.
// O tabelão só volta quando o BSeller não responde ou não traz esta entrega: aí o cabeçalho
// diz que é a cópia do banco. A API SAC manda só o dia do ponto, sem a hora.

function soNumero(valor) {
  return String(valor ?? '').trim().split('.')[0];
}

// '2026-10-26' / '2026-10-26T10:30:00' -> '26/10/2026' / '26/10/2026 10:30'; o resto volta como veio.
export function dataPontoBR(valor) {
  const s = String(valor ?? '').trim();
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2}))?/);
  if (!m) return s;
  const dia = `${m[3]}/${m[2]}/${m[1]}`;
  return m[4] && `${m[4]}:${m[5]}` !== '00:00' ? `${dia} ${m[4]}:${m[5]}` : dia;
}

// A entrega deste card na resposta do BSeller. A API devolve todas as entregas do pedido:
// vale só a de mesmo número; sem ela, nada (nunca a de outra entrega do mesmo pedido).
export function entregaDoCard(rastreio, numeroEntrega) {
  if (!rastreio || rastreio.status !== 'ok') return null;
  const alvo = soNumero(numeroEntrega);
  if (!alvo) return null;
  return (rastreio.entregas || []).find((e) => soNumero(e.id_entrega) === alvo) || null;
}

// A tela guarda a resposta junto do número que consultou: { numero, resposta } (resposta null =
// a consulta falhou). Resposta de outro número, ou nenhuma ainda, vale como "consultando": o card
// acabou de abrir ou trocou de pedido. Antes, por um instante, aparecia o tabelão com a marca
// "o BSeller não respondeu" sem o BSeller ter sido consultado (ressalva a da revisão de 26/10).
export function rastreioDoCard(guardado, numeroEntrega) {
  if (!guardado || !soNumero(numeroEntrega)) return undefined;
  if (soNumero(guardado.numero) !== soNumero(numeroEntrega)) return undefined;
  return guardado.resposta ?? null;
}

// rastreio: undefined = consultando o BSeller; null = a consulta falhou; objeto = a resposta.
// Devolve { status, data, fonte } com fonte 'bseller', 'consultando' ou 'tabelao'.
export function statusCabecalho(pedidoErp, rastreio) {
  const tabelao = {
    status: (pedidoErp && pedidoErp.status_pedido) || '',
    data: (pedidoErp && pedidoErp.data_status) || '',
  };
  if (rastreio === undefined) return { status: '', data: '', fonte: 'consultando' };
  const ent = entregaDoCard(rastreio, pedidoErp && pedidoErp.numero_pedido);
  if (ent && ent.ponto_descricao) {
    return { status: ent.ponto_descricao, data: dataPontoBR(ent.data_ponto), fonte: 'bseller' };
  }
  return { ...tabelao, fonte: 'tabelao' };
}
